<template>
  <div class="sub-page-v2">
    <div class="page-hero-small party-detail-hero">
      <h1>{{ $t('common.party') }}</h1>
    </div>
    <div class="container-v2 page-body-v2">
      <div class="content-v2">
        <BreadcrumbV2 :items="breadcrumbItems" />
        <article class="party-article">
          <h1>{{ article.title }}</h1>
          <div class="article-meta">
            <span v-if="article.date">{{ article.date }}</span>
            <span v-if="article.source">{{ article.source }}</span>
            <span v-if="article.author">{{ article.author }}</span>
          </div>
          <div class="article-cover" v-if="article.image">
            <img :src="article.image" :alt="article.title" />
          </div>
          <div class="article-body" v-html="article.content"></div>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import BreadcrumbV2 from '@/components/BreadcrumbV2.vue'
import { getPartyArticleDetail } from '@/api/portal'
import { resolveFileUrl } from '@/utils/request'

export default {
  name: 'PartyDetailV2',
  components: { BreadcrumbV2 },
  data() {
    return {
      breadcrumbItems: [
        { nameKey: 'common.party', path: '/party' }
      ],
      article: {
        title: '',
        date: '',
        source: '',
        author: '',
        image: '',
        content: ''
      }
    }
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler() {
        this.loadDetail()
      }
    }
  },
  methods: {
    loadDetail() {
      const id = this.$route.params.id
      if (!id) {
        return
      }
      getPartyArticleDetail(id).then(data => {
        if (!data || !data.articleId) {
          return
        }
        this.article = {
          title: data.articleTitle,
          date: data.publishTime || '',
          source: data.source || '',
          author: data.author || '',
          image: resolveFileUrl(data.coverUrl),
          content: data.articleContent || data.summary || ''
        }
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.party-detail-hero {
  background:
    radial-gradient(circle at 76% 24%, rgba(255,255,255,0.14), transparent 28%),
    linear-gradient(135deg, #7f1d1d, #991b1b 58%, #0f172a);
}

.party-article {
  max-width: 860px;
  margin: 0 auto;
  padding: 44px;
  background: #fff;
  border-radius: 22px;
  box-shadow: 0 12px 42px rgba(15, 23, 42, 0.07);

  h1 {
    color: #0f172a;
    font-size: 32px;
    font-weight: 800;
    line-height: 1.45;
  }
}

.article-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 18px;
  margin: 18px 0 30px;
  padding-bottom: 22px;
  border-bottom: 1px solid #e2e8f0;
  color: #94a3b8;
  font-size: 14px;
}

.article-cover {
  margin-bottom: 32px;
  border-radius: 18px;
  overflow: hidden;
  background: #f8fafc;

  img {
    width: 100%;
    max-height: 460px;
    object-fit: contain;
    display: block;
  }
}

.article-body {
  color: #475569;
  font-size: 17px;
  line-height: 2;

  ::v-deep p {
    margin-bottom: 18px;
  }

  ::v-deep img {
    max-width: 100%;
    height: auto;
  }
}

@media (max-width: 640px) {
  .party-article {
    padding: 26px 20px;

    h1 {
      font-size: 25px;
    }
  }
}
</style>
